// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1qhBq","info":"PatientInfo_info__HecjD"};